import { Flex, Row, Space, Button } from "antd";
// import { Button } from "components/elements";
import CompanyTree from "./CompanyTree";
import { useSelector } from "react-redux";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";
import { toJpeg, toPng } from 'html-to-image';
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";
import { useRef, useState } from "react";

const CompanyPositionView = ({
  onCancel = () => { },
  onEdit = () => { },
  positionList = [],
  lang = "",
}) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const downloadImage = () => {
    const chartElement = document.getElementById('chart');

    // Temporarily expand the div to capture all content
    const originalWidth = chartElement.style.width;
    const originalHeight = chartElement.style.height;

    chartElement.style.width = `${chartElement.scrollWidth}px`;
    chartElement.style.height = `${chartElement.scrollHeight}px`;

    const scale = 10; // Increase resolution (optional)

    toJpeg(chartElement, {
      width: chartElement.scrollWidth * scale,
      height: chartElement.scrollHeight * scale,
      backgroundColor: "white",
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${chartElement.scrollWidth}px`,
        height: `${chartElement.scrollHeight}px`,
      },
    })
      .then((dataUrl) => {
        // Reset styles
        chartElement.style.width = originalWidth;
        chartElement.style.height = originalHeight;

        // Trigger download
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'โครงสร้างตำแหน่งงาน.png';
        link.click();
      })
      .catch((error) => {
        console.error('Could not generate image', error);
      });
  };

  return (
    <Space
      className={styles.container}
      direction="vertical"
      size={24}
      style={{ overflow: "auto" }}
    >
      <Row justify="end" className={styles.container}>
        <Space size={12}>
          <Button type="default"
            onClick={async () => {
              setIsLoading(true);
              try {
                const res = await containerRef?.current?.compact?.(false).render().fit().render();
                if (res) {
                  await new Promise((resolve) => setTimeout(resolve, 2000));
                  downloadImage();
                }
              } catch (err) {
                console.error("Download error", err);
              } finally {
                setIsLoading(false);
              }
            }}
            style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}
            loading={isLoading}
            disabled={isLoading}
          >
            {t("common.download")}
          </Button>
          {/* <Button type="default" onClick={onCancel} style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <ImportIcon />
              <span>{t('common.import')}</span>
            </Flex>
          </Button> */}
          {
            (roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|POSITION") || roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|POSITION")) &&
            <Button type="primary" onClick={onEdit} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
              <Flex align="center" justify="center" gap={8}>
                <EditIcon />
                {t("common.edit").toUpperCase()}
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      <div className="card" style={{ overflow: "auto", boxShadow: "none" }}>
        <CompanyTree data={positionList} lang={lang} graphRef={containerRef} />
      </div>
    </Space>
  );
};

export default CompanyPositionView;
